//
// Module for the Withholding What-If Index view
//
rs.module("content/participant/benefit/withholdingwhatif/index",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the page
        function initialize(jsSelectors) {

            // clear event banner as the user switches tabs
            $.js(jsSelectors.tabs).find("[data-js=_tab]").click(function () {
                eventBanner.removeAllMessages();
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);